import classnames from 'classnames';

import TOC from '@/components/TOC';

export default function ContentWithTOC({
  page,
  togglerRequired,
  wrapperClass = '',
  children,
  ...props
}) {
  const h2Regexp = /^(## .*[\n\r\v\t\s]*)$/gim;
  const contentHeading2 = page.content.match(h2Regexp);
  const links = contentHeading2
    ? contentHeading2.map((link) => link.slice(3))
    : [];
  const isCustomerPresent = page.customer !== undefined;
  const sectionClass = classnames(
    wrapperClass,
    'max-w-3xl mx-auto xl:flex xl:flex-nowrap xl:flex-row',
  );
  const asideClass = classnames(
    'w-full mt-8 max-h-screen xl:order-first xl:sticky xl:-ml-60 xl:mr-12 xl:w-56 xl:self-start',
    {
      'mb-16': isCustomerPresent,
    },
  );

  if (!links.length) return null;

  return (
    <section className={sectionClass}>
      <aside className={asideClass} style={{ top: '160px' }}>
        <TOC links={links} togglerRequired={togglerRequired} {...props} />
      </aside>
      <main className="xl:order-last xl:max-w-3xl xl:flex-grow">
        {children}
      </main>
    </section>
  );
}
